import axios from "axios";
import { plainToInstance } from "class-transformer";
import { ConsentConfig, ConsentConfigTemplate } from "healthex-common/consentconfig.dtos";
import { authenticatedApiConfig } from "./BaseApiService";
export class ConsentConfigService {
    constructor(authenticationProvider, environment) {
        this.authenticationProvider = authenticationProvider;
        this.environment = environment;
    }
    async getConsentConfig(organizationId) {
        const response = await axios.get(`${this.environment.API_BASE_URL}/organizations/${organizationId}/consent-config`, authenticatedApiConfig(this.authenticationProvider));
        return response.data === "" ? null : plainToInstance(ConsentConfig, response.data);
    }
    async updateConsentConfig(organizationId, consentConfigInput) {
        await axios.put(`${this.environment.API_BASE_URL}/organizations/${organizationId}/consent-config`, consentConfigInput, authenticatedApiConfig(this.authenticationProvider));
    }
    async getDefaultConsentConfigTemplate() {
        const response = await axios.get(`${this.environment.API_BASE_URL}/consent-config/templates/default`, authenticatedApiConfig(this.authenticationProvider));
        return response.data === "" ? null : plainToInstance(ConsentConfigTemplate, response.data);
    }
}
